import { Config } from "src/modules/app-template/models/config.model";
import { CorporateIdentity } from "src/modules/app-template/models/corporate-identity.model";

export const environment : Partial<Config> = {
    pageTitle: "Rungis Lieferantenportal",
    
    production: true,
    activeModules: ["RungisSupplierModule"],
    reportErrorsToBackend: true,
    allowAnonymous: true,
    showSidebar: false,
	multilingual: true,
    ci: new CorporateIdentity({
        topbarBgColor: "#265d38",
        topbarBgColorDark: "#265d38",
        badgeColor: "#e42a7b",
        primaryColor: "#265d38",
        primaryTextColor: "#ffffff",
        topbarLogoHeight: "115px",
        topbarLogoPadding: "3px",
        topbarLogoBgColor: "white",
        loginLogoBackgroundColor: "white",
    }), 
	staticHeaderHtml: "<span class=\"primary-color ml-8 font-bold font-size-24\"><u>Bitte die Befüllung der Felder nur auf Deutsch oder Englisch vornehmen!</u></a>"  

};